export class EventBus {
  eventMap: Record<string, ((params?: any) => void)[]> = {};

  on = (name: string, cb: (params?: any) => void): void => {
    if (this.eventMap[name]) {
      this.eventMap[name].push(cb);
    } else {
      this.eventMap[name] = [cb];
    }
  };

  off = (name: string, cb: (params?: any) => void): void => {
    if (this.eventMap[name]) {
      this.eventMap[name] = this.eventMap[name].filter((fn) => fn !== cb);
    }
  };

  emit = (name: string, params?: any): void => {
    this.eventMap[name]?.forEach((cb) => {
      cb(params);
    });
  };
}

const eventBus = new EventBus();

export default eventBus;
